import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Subscription } from 'rxjs';
import { getDefaultLogo } from 'src/app/core/utils/default-logo.util';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
  authSubscription: Subscription;
  isAuthenticated: boolean | undefined = undefined;
  logo = getDefaultLogo();

  constructor(public auth: AuthService) { }

  ngOnInit(): void {
    this.authSubscription = this.auth.isAuthenticated$.subscribe(result => this.isAuthenticated = result);
  }

  ngOnDestroy(): void {
    this.authSubscription?.unsubscribe();
  }

  loginWithMicrosoft(): void {
    this.auth.loginWithRedirect({ authorizationParams: { connection: 'windowslive' } });
  }

  loginWithGoogle(): void {
    this.auth.loginWithRedirect({ authorizationParams: { connection: 'google-oauth2' } });
  }

  loginWithEmail(): void {
    this.auth.loginWithRedirect({ authorizationParams: { connection: 'email' } });
  }
}
